// Security Manager
export class SecurityManager {
  constructor() {
    this.nonce = this.generateNonce();
    this.init();
  }

  generateNonce() {
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    return btoa(String.fromCharCode.apply(null, array));
  }

  init() {
    this.initCSP();
    this.initIntegrityChecks();
    this.preventClickjacking();
  }

  initCSP() {
    const cspMeta = document.createElement('meta');
    cspMeta.httpEquiv = 'Content-Security-Policy';

    // In production, only allow 'self' and trusted third-party APIs
    // No localhost connections allowed to prevent CORS errors
    // Including Railway backend for voice agent middleware
    const connectSrc = "'self' https://elevenlabs.io https://*.elevenlabs.io wss://*.elevenlabs.io https://api.openai.com https://cdn.jsdelivr.net https://inboundai365-backend-production.up.railway.app";

    // Note: Using 'unsafe-inline' for script-src to support:
    // 1. Inline module scripts (ElevenLabs SDK in contact.html)
    // 2. Dynamically generated speculation rules scripts
    // 3. Other inline scripts across the application
    // Also including blob: and data: for AudioWorklet processors (required for WebRTC voice)
    // Consider implementing nonces or hashes in a future security audit
    cspMeta.content = `
      default-src 'self';
      script-src 'self' 'unsafe-inline' blob: data: https://elevenlabs.io https://cdn.jsdelivr.net;
      style-src 'self' 'unsafe-inline' https://fonts.googleapis.com;
      img-src 'self' data: https:;
      font-src 'self' data: https://fonts.gstatic.com;
      connect-src ${connectSrc};
      worker-src 'self' blob:;
      media-src 'self' blob:;
      base-uri 'self';
      form-action 'self';
    `.replace(/\s+/g, ' ').trim();

    document.head.appendChild(cspMeta);
  }

  initIntegrityChecks() {
    document.querySelectorAll('script[src], link[rel="stylesheet"]').forEach(element => {
      const src = element.src || element.href;
      if (!element.integrity && src && !src.startsWith(location.origin)) {
        console.warn('Missing SRI for external resource:', src);
      }
    });
  }

  preventClickjacking() {
    if (window.self !== window.top) {
      console.warn('Possible clickjacking attempt detected');
    }
  }

  sanitizeHTML(html) {
    const template = document.createElement('template');
    template.innerHTML = html;

    const scripts = template.content.querySelectorAll('script');
    scripts.forEach(script => script.remove());

    const elements = template.content.querySelectorAll('*');
    elements.forEach(element => {
      for (const attr of element.attributes) {
        if (attr.name.startsWith('on')) {
          element.removeAttribute(attr.name);
        }
      }
    });

    return template.innerHTML;
  }

  validateInput(input, type) {
    const validators = {
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      url: /^https?:\/\/.+/,
      alphanumeric: /^[a-zA-Z0-9]+$/,
      numeric: /^\d+$/
    };

    if (validators[type]) {
      return validators[type].test(input);
    }

    return false;
  }

  escapeHTML(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  getNonce() {
    return this.nonce;
  }
}

export default SecurityManager;
